<
<template>
	<div class="c-popup-board-options" v-if="target && buttonSelector">
		<Popup
			:buttonSelector="buttonSelector"
			:active="options.active"
			:target="target"
			@onClose="onClose"
			:offset="offset"
		>
			<div class="c-popup-board-options__inner">
				<a v-if="!board.default" href="#" @click.prevent="onEditBoard">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M4 3C2.89543 3 2 3.89543 2 5V18C2 19.1046 2.89543 20 4 20H19.5C19.9374 20 20.324 19.7157 20.4545 19.2983L22.7516 11.9474C23.0535 10.9815 22.3319 10 21.3199 10H21V8C21 6.89543 20.1046 6 19 6H12.5352L11.1289 3.8906C10.758 3.3342 10.1335 3 9.46482 3H4ZM19 10V8H12C11.6656 8 11.3534 7.8329 11.1679 7.5547L9.46482 5L4 5V18H4.76481L6.82623 11.4035C7.08715 10.5685 7.86042 10 8.73519 10H19Z"
							fill="currentColor"
						/>
					</svg>
					<span> Edit Board </span>
				</a>

				<a href="#" @click.prevent="onCloneBoard">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M9 8V9M9 5V4C9 3.44772 9.44772 3 10 3H11M19 3H20C20.5523 3 21 3.44772 21 4V5M14 3H16M21 8V10M21 13V14C21 14.5523 20.5523 15 20 15H19M16 15H15M14.5 9H3.5C3.22386 9 3 9.22386 3 9.5V20.5C3 20.7761 3.22386 21 3.5 21H14.5C14.7761 21 15 20.7761 15 20.5V9.5C15 9.22386 14.7761 9 14.5 9Z"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
					<span> Clone board </span>
				</a>

				<a href="#" class="danger" @click.prevent="onDelete">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M2 5C2 3.89543 2.89543 3 4 3H9.46482C10.1335 3 10.758 3.3342 11.1289 3.8906L12.5352 6H20C21.1046 6 22 6.89543 22 8V18C22 19.1046 21.1046 20 20 20H9.82917C10.1839 18.9942 9.98621 17.8371 9.23618 17C10.2916 15.8221 10.2533 14.0106 9.12132 12.8787C7.98937 11.7467 6.17791 11.7084 5 12.7638C4.16288 12.0138 3.00578 11.8161 2 12.1708V5Z"
							fill="currentColor"
						/>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M7.70711 14.2929C8.09763 14.6834 8.09763 15.3166 7.70711 15.7071L6.41421 17L7.70711 18.2929C8.09763 18.6834 8.09763 19.3166 7.70711 19.7071C7.31658 20.0976 6.68342 20.0976 6.29289 19.7071L5 18.4142L3.70711 19.7071C3.31658 20.0976 2.68342 20.0976 2.29289 19.7071C1.90237 19.3166 1.90237 18.6834 2.29289 18.2929L3.58579 17L2.29289 15.7071C1.90237 15.3166 1.90237 14.6834 2.29289 14.2929C2.68342 13.9024 3.31658 13.9024 3.70711 14.2929L5 15.5858L6.29289 14.2929C6.68342 13.9024 7.31658 13.9024 7.70711 14.2929Z"
							fill="currentColor"
						/>
					</svg>

					<span> Delete Board </span>
				</a>
			</div>
		</Popup>
	</div>
</template>

<script>
import Popup from './index';

export default {
	components: {
		Popup,
	},

	data: function () {
		return {
			offset: [0, 4],
			options: {
				active: false,
			},
			tags: [
				{
					name: 'All Ads',
					slug: 0,
				},
				{
					name: 'Active',
					slug: 1,
				},
				{
					name: 'Inactive',
					slug: 2,
				},
			],
			selectedActiveAds: 0,
		};
	},

	props: {
		active: {
			type: Boolean,
			default: false,
		},
		target: {},
		board: {},
		type: {
			type: String,
		},
	},

	watch: {
		active: function () {
			setTimeout(() => {
				if (this.active) {
					this.options.active = true;
				} else {
					this.options.active = false;
				}
			}, 1);
		},
		selectedActiveAds: function () {
			this.$emit('input', this.selectedActiveAds);
		},
	},

	computed: {
		buttonSelector: function () {
			if (!this.target) {
				return;
			}
			let classList = this.target.classList;

			if (classList.length < 2) {
				return;
			}

			let selector = classList[1];

			return selector;
		},
	},

	methods: {
		onEditBoard: function () {
			this.$emit('onClose');
			this.$store.dispatch('boards/setEdit', this.board.id);
		},
		onCloneBoard: function () {
			this.$emit('onClose');
			this.$emit('onClone', this.board);
		},

		onDelete: function () {
			this.$emit('onClose');
			this.$emit('onDelete', this.board);
		},

		onClose: function () {
			this.$emit('onClose');
		},
	},

	created: function () {},
};
</script>

<style lang="scss">
.c-popup-board-options {
	.c-popup {
		width: 160px;

		background-color: hsl(var(--p), 5%, 18%);
		box-shadow: inset 0 -1px 1px #0000001a, inset 0 1px 1px #ffffff08,
			inset 0 5px 20px 1px #ffffff05, 0 2px 5px #3c42570a, 0 1px 1px #0000000f,
			0 0 0 1px #00000013;
		transition: all var(--transition-time) ease-out;

		&__arrow {
			display: none;
		}
	}
	article {
		//padding: var(--margin) var(--margin-lg);
	}

	&__inner {
		border-radius: var(--border-radius-lg);
		overflow: hidden;
		a {
			width: 100%;
			display: flex;
			padding: var(--margin);
			align-items: center;
			color: var(--color-font);
			font-weight: 500;
			font-size: var(--font-size-xs);
			transition: all 120ms ease-out;
			text-decoration: none !important;
			user-select: none;

			&.danger {
				color: var(--color-danger);
			}

			svg {
				width: 20px;
				height: 20px;
				margin-right: var(--margin);
			}

			span {
				line-height: 1;
			}

			&:hover,
			&:active {
				color: var(--color-font);
				background-color: hsl(var(--p), 5%, 24%);
			}

			&:not(:last-child) {
				border-bottom: hsl(var(--p), 5%, 24%) solid 1px;
			}

			&.danger {
				&:hover,
				&:active {
					color: var(--color-danger);
					background-color: hsl(var(--p), 5%, 24%);
				}
			}
		}
	}
}
</style>
